import CakeIcon from '@mui/icons-material/Cake';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../../extension/interface/benefit-metadata.extension.interface';

export class GiftsBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Gifts;
  get Icon(): React.ComponentType<SvgIconProps> {
    return CakeIcon;
  }
}
